<div class="control-section" *ngIf="dataEncuestas">
	<div class="validation-stepper-section">

	<div class="alert alert-warning">
		<strong>Atención:</strong> Si sales de esta sección, todas las respuestas seleccionadas en el formulario se perderán.
	</div>
	<br>

	  <ejs-stepper
		#validationStepper
		linear="true"
		(stepChanging)="StepChange($event)"
		(created)="StepCreated()"
		[activeStep]="activeStep"
	  >
	  <e-steps>
		<e-step *ngFor="let seccion of dataEncuestas.CLI16ARC; let i = index" [label]="seccion.CLI16DES" iconCss="sf-icon-survey-intro" [isValid]="formOk[i]?.value">
		</e-step>
	  </e-steps>
	  </ejs-stepper>
  
	  <br>
  
	  <div *ngFor="let formGroup of Formularios; let i = index">
		<div [ngClass]="{'d-none': activeStep !== i}" [formGroup]="formGroup">
		  <div *ngFor="let pregunta of dataEncuestas.CLI16ARC[i].CLI11ARC">
			<p><strong>{{ pregunta.CLI01ENU }}</strong></p>

			<!-- INFORMACIÓN (Sufijo / Unidad medida) -->
			<small style="float: right; color: grey; font-weight: bold;font-size: 11px; opacity: 0.7;">{{pregunta.CLI01SUU ?? ''}}</small>
			
			<ng-container [ngSwitch]="pregunta.CLI01TRE">
			  <!-- ABIERTA -->
			  <div *ngSwitchCase="'A'">
				<!-- <input type="text" [formControl]="formGroup.get(pregunta.CLI11COD)" [maxlength]="pregunta.CLI01LOG" class="form-control"> -->
				<textarea [formControl]="formGroup.get(pregunta.CLI11COD)" rows="5" [maxlength]="pregunta.CLI01LOG" class="form-control"></textarea>
				<div class="character-count mt-2">
					<small style="font-size: 11px;">
					  Quedan <strong>{{ pregunta.CLI01LOG - formGroup.get(pregunta.CLI11COD).value.length }}</strong> caracteres disponibles de un total de <strong>{{ pregunta.CLI01LOG }}</strong>.
					</small>
				  </div>
				<br>
				<div *ngIf="pregunta.CLI01MAY == 'S'" class="alert alert-info">
					<strong>AYUDA:</strong> {{pregunta.CLI01AYU}}
				</div>
				<div *ngIf="formGroup.get(pregunta.CLI11COD).invalid && (formGroup.get(pregunta.CLI11COD).dirty|| formGroup.get(pregunta.CLI11COD).touched)">
				  	<small class="text-danger infoText" *ngIf="formGroup.get(pregunta.CLI11COD).errors?.required">Este campo es requerido</small>
					<small class="text-danger infoText" *ngIf="formGroup.get(pregunta.CLI11COD).errors?.pattern && pregunta.CLI01CAP === 'AB'">Por favor, ingresa solo letras del alfabeto</small>
					<small class="text-danger infoText" *ngIf="formGroup.get(pregunta.CLI11COD).errors?.pattern && pregunta.CLI01CAP === 'CE'">Por favor, el texto cuenta con carateres especiales no validos</small>
					<small class="text-danger infoText" *ngIf="formGroup.get(pregunta.CLI11COD).errors?.pattern && pregunta.CLI01CAP === 'NU'">Por favor, ingresa solo números</small>
				</div>
			  </div>

			  <!-- CALIFICACIÓN -->
			<div *ngSwitchCase="'CL'">
				<div *ngIf="this.Tipo !== 'Aplicada'">
					<app-star-rating 
					[value]="formGroup.get(pregunta.CLI11COD).value" 
					[maxRating]="pregunta.CLI01LOG" 
					(valueChanged)="onValueChanged($event, pregunta.CLI11COD, formGroup)"
					[itemsCount]="pregunta.CLI20ARC.length"
					[lstTags]="getTags(pregunta.CLI20ARC)">
					</app-star-rating>
					<br>
					<div *ngIf="pregunta.CLI01MAY == 'S'" class="alert alert-info">
						<strong>AYUDA:</strong> {{pregunta.CLI01AYU}}
					</div>
					<div *ngIf="formGroup.get(pregunta.CLI11COD).touched">
						<small class="text-danger infoText" *ngIf="formGroup.get(pregunta.CLI11COD).hasError('noZero')">
							Este campo es requerido, debes seleccionar como mínimo un valor
						</small>
					</div>
				</div>
				<!-- Para mostrar datos -->
				<div *ngIf="this.Tipo == 'Aplicada'">
					<app-star-rating 
					[value]="getCLI22RES(pregunta.CLI20ARC)" 
					[maxRating]="pregunta.CLI01LOG" 
					[itemsCount]="pregunta.CLI20ARC.length"
					[lstTags]="getTags(pregunta.CLI20ARC)">
					</app-star-rating>
					<br>
					<div *ngIf="pregunta.CLI01MAY == 'S'" class="alert alert-info">
						<strong>AYUDA:</strong> {{pregunta.CLI01AYU}}
					</div>
				</div>
			</div>
  
			  <div *ngSwitchCase="'Combo'">
				<select [formControl]="formGroup.get(pregunta.CLI11COD)" class="form-select">
				  <option *ngFor="let respuesta of pregunta.CLI20ARC" [value]="respuesta.CLI20COD">
					{{ respuesta.CLI02ENU }}
				  </option>
				</select>
				<div *ngIf="formGroup.get(pregunta.CLI11COD).invalid && formGroup.get(pregunta.CLI11COD).touched">
				  <small class="text-danger infoText">Este campo es requerido</small>
				</div>
			  </div>
			
			  <div *ngSwitchCase="'Numero'">
				<input type="number" [formControl]="formGroup.get(pregunta.CLI11COD)" class="form-control">
				<div *ngIf="formGroup.get(pregunta.CLI11COD).invalid && formGroup.get(pregunta.CLI11COD).touched">
				  <small class="text-danger infoText">Este campo es requerido</small>
				</div>
			  </div>
			
			  <div *ngSwitchCase="'DatePicker'">
				<input type="date" [formControl]="formGroup.get(pregunta.CLI11COD)" class="form-control">
				<div *ngIf="formGroup.get(pregunta.CLI11COD).invalid && formGroup.get(pregunta.CLI11COD).touched">
				  <small class="text-danger infoText">Este campo es requerido</small>
				</div>
			  </div>
			
			  <!-- RESPUESTA MULTIPLE -->
			  <div *ngSwitchCase="'SM'">
				<div *ngIf="this.Tipo !== 'Aplicada'">
					<div [formArrayName]="pregunta.CLI11COD">
						<div *ngFor="let respuesta of pregunta.CLI20ARC; let j = index">
							<input 
							type="checkbox" 
							[formControlName]="j"
							[value]="pregunta.CLI02RES"
							>
							{{ respuesta.CLI02ENU }}
						</div>
					</div>
					<br>
					<div *ngIf="pregunta.CLI01MAY == 'S'" class="alert alert-info">
						<strong>AYUDA:</strong> {{pregunta.CLI01AYU}}
					</div>
					<div *ngIf="formGroup.get(pregunta.CLI11COD).hasError('required') && formGroup.get(pregunta.CLI11COD).touched">
						<small class="text-danger infoText">Debes seleccionar al menos una opción</small>
					</div>	
				</div>	
				<div *ngIf="this.Tipo == 'Aplicada'">
					<div *ngFor="let respuesta of pregunta.CLI20ARC; let j = index">
						<input *ngIf="respuesta.CLI20COD === respuesta.CLI22RES"
						type="checkbox" 
						[value]="pregunta.CLI02RES"
						checked
						>
						<input *ngIf="respuesta.CLI20COD !== respuesta.CLI22RES"
						type="checkbox" 
						[value]="pregunta.CLI02RES"
						>
						{{ respuesta.CLI02ENU }}
					</div>
					<br>
					<div *ngIf="pregunta.CLI01MAY == 'S'" class="alert alert-info">
						<strong>AYUDA:</strong> {{pregunta.CLI01AYU}}
					</div>
				</div>		  
			  </div>
			
			  <!-- SELECCIÓN ÚNICA -->
			  <div *ngSwitchCase="'C'">
				<div *ngIf="this.Tipo !== 'Aplicada'">
					<div *ngFor="let respuesta of pregunta.CLI20ARC">
					  <input 
						type="radio" 
						[formControlName]="pregunta.CLI11COD" 
						[value]="respuesta.CLI20COD"
						[attr.name]="pregunta.CLI11COD"
					  >
					  {{ respuesta.CLI02ENU }}
					</div>
					<br>
					<div *ngIf="pregunta.CLI01MAY == 'S'" class="alert alert-info">
						<strong>AYUDA:</strong> {{pregunta.CLI01AYU}}
					</div>
					<div *ngIf="formGroup.get(pregunta.CLI11COD).invalid && formGroup.get(pregunta.CLI11COD).touched">
					  <small class="text-danger infoText">Este campo es requerido</small>
					</div>
				</div>
				<div *ngIf="this.Tipo == 'Aplicada'">
					<div *ngFor="let respuesta of pregunta.CLI20ARC">
						<input *ngIf="respuesta.CLI20COD === respuesta.CLI22RES"
							type="radio" 
							[value]="respuesta.CLI20COD"
							[attr.name]="pregunta.CLI11COD"
							checked
						>
						<input *ngIf="respuesta.CLI20COD !== respuesta.CLI22RES"
							type="radio" 
							[value]="respuesta.CLI20COD"
							[attr.name]="pregunta.CLI11COD"
						>
						{{ respuesta.CLI02ENU }}
					</div>
					<br>
					<div *ngIf="pregunta.CLI01MAY == 'S'" class="alert alert-info">
						<strong>AYUDA:</strong> {{pregunta.CLI01AYU}}
					</div>
				</div>
			  </div>

			  <!-- GRADIENTE -->
			  <div *ngSwitchCase="'GR'">
				<br>
				<div *ngIf="this.Tipo !== 'Aplicada'">
					<div class="row">
						<div class="col-md-12">
						  <app-slider-sf 
							[remarks]="getRemarks(pregunta.CLI20ARC)"
							[min]="getMin(pregunta.CLI20ARC)"
							[max]="getMax(pregunta.CLI20ARC)"
							[value]="getMin(pregunta.CLI20ARC)" 
							(valueChanged)="onValueChanged($event, pregunta.CLI11COD, formGroup)">
						  </app-slider-sf>
						</div>
						<!-- <div class="col-md-1">
						  <p class="fw-bold fs-8">{{ formGroup.get(pregunta.CLI11COD).value }}</p>
						</div> -->
					</div>	
					<br>
					<br>
					<div *ngIf="pregunta.CLI01MAY == 'S'" class="alert alert-info">
						<strong>AYUDA:</strong> {{pregunta.CLI01AYU}}
					</div>			  
					<div *ngIf="formGroup.get(pregunta.CLI11COD).touched">
						<small class="text-danger infoText" *ngIf="formGroup.get(pregunta.CLI11COD).hasError('noZero')">
							Este campo es requerido y no puede ser 0
						</small>
					</div>
				</div>
				<div *ngIf="this.Tipo == 'Aplicada'">
					<div class="row">
						<div class="col-md-12">
						  <app-slider-sf 
							[remarks]="getRemarks(pregunta.CLI20ARC)"
							[min]="getMin(pregunta.CLI20ARC)"
							[max]="getMax(pregunta.CLI20ARC)"
							[value]="getCLI22RES(pregunta.CLI20ARC)" >
						  </app-slider-sf>
						</div>
						<div class="col-md-3">
						  <br><br>
						  <p class="fw-bold fs-8">Valor seleccionado: {{ getCLI22RES(pregunta.CLI20ARC) }} </p>
						</div>
					</div>	
					<br>
					<br>
					<div *ngIf="pregunta.CLI01MAY == 'S'" class="alert alert-info">
						<strong>AYUDA:</strong> {{pregunta.CLI01AYU}}
					</div>	
				</div>
			  </div>			
										
			  <br>
			</ng-container>
		  </div>
		<div *ngIf="hayErrores" class="alert alert-warning">
			<strong>Advertencia:</strong> Por favor, completa todos los campos requeridos en los formularios antes de confirmar.
		</div>
		</div>
	  </div>
  
	  <div class="navigation-buttons mt-3">
		<button *ngIf="activeStep > 0" class="btn btn-primary me-2" (click)="previousStep()">Anterior</button>
		
		<button class="btn btn-success" (click)="nextStep()">
		  {{ activeStep === Formularios.length - 1 ? 'Confirmar' : 'Siguiente' }}
		</button>
		<br><br>
		<div class="alert alert-warning">
			<strong>Atención:</strong> Si sales de esta sección, todas las respuestas seleccionadas en el formulario se perderán.
		</div>
	  </div>
	</div>
  </div>
